export const kioskInitialState = {
  subjectFilter: {
    title: 'filter:subject',
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    platform: 'kiosk',
    componentName: 'subjectFilter',
    translateKey: 'filter:subject',
    isDisabled: true,
    hasActivateSwitch: true,
  },
  resourceCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: '',
    platform: 'kiosk',
    componentName: 'resourceCategoryFilter',
    translateKey: 'filter:resourceCategory',
    isDisabled: true,
    hasActivateSwitch: true,
    hasIncludeExclude: false,
    filterType: 'include',
  },
  resourcesFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'include',
    selectedItems: {},
    hasIncludeExclude: true,
    platform: 'kiosk',
    componentName: 'resourcesFilter',
    translateKey: 'filter:resourceSearch',
    isDisabled: true,
    hasActivateSwitch: true,
  },
};
